import _         from "lodash";
import Formatter from "utils/formatter";

/**
 * Handles the downloading of csv file
 */
class CSVReport {

    constructor(type, app) {
        this.reportType = type;
        this.app        = app;
        this.formatter  = new Formatter();
    }

    /**
     * Validates if all necessary data is available
     */
    _validate() {
        if (!this.app.get('REPORT.DATASET')) {
            alert('There is no data to download');
            return false;
        }

        if (!this.app.get(`active.${this.reportType}`)) {
            alert(`Error retrieving your ${this.reportType} data`);
            return false;
        }

        return true;
    }

    /**
     * Get the subject of the report
     */
    _getReportSubject() {
        let name = '';
        
        if (this.reportType === 'resource') {
            name = this.app.get('active.resource').bindname;
        }

        if (this.reportType === 'project') {
            name = this.app.get('active.project').ProjectID;
            name = `Project${name}`;
        }

        return name;
    }

    /**
     * Creates the filename for the report
     */
    createFilename() {
        if (!this._validate()) return;

        let dateRange = this.app.get('dateRange');
        let name      = this._getReportSubject();

        return `${name}_${dateRange.from}_${dateRange.to}.csv`;
    }

    /**
     * Prepares the data of the report
     * 
     * @param {array} columns - Needed columns on the report
     */
    assembleData(columns) {

        let rows      = [],
            header    = columns.join(","),
            dataset   = this.app.get('REPORT.DATASET'),
            resources = this.app.get('resources.lookup');
    
        rows.push(header);

        _.each(dataset, (value) => {
            let row = [];
    
            if (columns.indexOf("Date") !== -1)
                row.push(`"${value.date}"`);

            if (columns.indexOf("Project ID") !== -1)
                row.push(`"${value.projectId}"`);

            if (columns.indexOf("Project Name") !== -1)
                row.push(`"${value.projectName}"`);
    
            if (columns.indexOf("Task ID") !== -1)
                row.push(`"${value.taskId}"`);
        
            if (columns.indexOf("Task Name") !== -1)
                row.push(`"${value.activity.parsed}"`);
            
            if (columns.indexOf("Resource") !== -1) {
                let bindname = (value.resource.match(/^@/)) ? value.resource : `@${value.resource}`;
                let resource = resources[bindname];

                row.push(`"${resource.firstName} ${resource.lastName}"`);
            }
                
            if (columns.indexOf("Time Spent") !== -1)
                row.push(`"${this.formatter.formatHours(value.timeSpent.hours)}"`);
    
            rows.push(row.join(","));
        });

        return rows.join("\n");
    }

    /**
     * Assembles and downloads the file report
     * 
     * @param {string} filename - Filename of the report
     * @param {string} data - This is the content of the report
     */
    downloadFile(filename, data) {
    
        let blobFile = new Blob([data], {type: "text/csv"}),
            file     = document.createElement("a");
    
        file.download      = filename;
        file.href          = window.URL.createObjectURL(blobFile);
        file.style.display = "none";
        
        document.body.appendChild(file);
        file.click();
    }
}

module.exports = CSVReport;
